import { MergeOrUpdateStateAction } from '@tableau/vizportalclient-common-components';

import { ActionDialogBodyWithInlineErrorMessage,ActionDialogBodyWithInlineErrorMessageProps, ActionDialogBodyWithInlineErrorMessageState } from '~commonInfra/dialogs/ActionDialogBodyWithInlineErrorMessage';
import { openReactActionDialog } from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType} from '~commonInfra/services/ToasterService';

import { Messages } from '../../codegen/Localize';
import { DeleteMySavedPasswordsAndCredentialsRequest } from '../../connectivity/serverApi/requests/credentials/DeleteMySavedPasswordsAndCredentialsRequest';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import WebHttpClient from '../../httpClient/WebHttpClient';

const initialDialogState: ActionDialogBodyWithInlineErrorMessageState = {
};

export function showDeleteSavedPasswordActionDialog() {
    const initialBodyProps: ActionDialogBodyWithInlineErrorMessageProps = { dialogMessage: Messages.clearUserSavedCredentialsConfirmMessage() };
    const dialogInstance = openReactActionDialog<ActionDialogBodyWithInlineErrorMessageProps, ActionDialogBodyWithInlineErrorMessageState, IResult>({
        title: Messages.clearSavedCredentials(),
        actionName: Messages.clearSavedCredentialsConfirmButton(),
        actionDisabled: (props: ActionDialogBodyWithInlineErrorMessageProps, state: ActionDialogBodyWithInlineErrorMessageState) => { return false; },
        isActionDelete: true,
        action: (_, state, updateDialogState) => {
            return deleteSavedPassword(updateDialogState);
        },
        dialogWidth: TabDialogWidth.width375px,
        bodyComponent: ActionDialogBodyWithInlineErrorMessage,
        dismissDialogOnActionFailed: false,
        initialBodyProps,
        initialDialogState
    });
    return Promise.resolve(dialogInstance.result);
}

async function deleteSavedPassword(
    updateDialogState: React.Dispatch<MergeOrUpdateStateAction<ActionDialogBodyWithInlineErrorMessageState>>

) {
    const result = await WebHttpClient.sendRequest(new DeleteMySavedPasswordsAndCredentialsRequest());
    if (result.errors && result.errors.length) {
        updateDialogState({ errorMessage: Messages.clearSavedCredentialsError()});
        return Promise.reject();
    } else {
        ToasterService.instance.pop({
            type: ToastType.Info,
            text: Messages.clearSavedCredentialsSuccess()
        });
        return Promise.resolve(result);
    }
}